import * as ko from 'knockout';

import { BaseControl, IControlValue } from 'Core/Controls/BaseControl/BaseControl';
import { IControlParam } from 'Core/Screens/IScreen';
import { RenderModes } from "Core/Constant";

import IFrameConfigJson from 'Core/Controls/IFrame/Configs/iframe-config.json';
import { GeneralProperties } from 'Core/GeneralProperties/GeneralProperties';

import ViewTemplate from 'Core/Controls/IFrame/Templates/View.html';
import ToolBarTemplate from 'Core/Controls/IFrame/Templates/ToolBar.html';
import DesignTemplate from 'Core/Controls/IFrame/Templates/Design.html';
import { CookieManager } from '../../Common/CookieManager';

ko.templates['Core/Controls/IFrame/Templates/ToolBar'] = ToolBarTemplate;
ko.templates['Core/Controls/IFrame/Templates/View'] = ViewTemplate;
ko.templates['Core/Controls/IFrame/Templates/Edit'] = ViewTemplate;
ko.templates['Core/Controls/IFrame/Templates/Design'] = DesignTemplate;

export class IFrame extends BaseControl {
	private _url: KnockoutObservable<string>;
	private _heightPX: KnockoutObservable<number>;

	constructor(params: IControlParam) {
		super(params, IFrameConfigJson);

		this._url = ko.observable('');
		this.Init();
		this._model.subscribe(() => {
			if (this.Properties) {
				this.ApplyProperties();
			}
		});
	}

	Init(): void {
		this._url = ko.observable('');
		this._heightPX = ko.observable(null);
		this.ApplyProperties();
	}

	GetDesignerHeight(): string {
		return `${+this._heightPX()}px`;
	}

	ApplyProperties() {
		if (this.Properties) {
			if (this.Properties.Url) {
				_.each(this.Properties.Url.Properties, (property: any) => {
					if (property.Url) {
						let url = property.Url as string;

						if(url.indexOf('api/BIApi/GetDashboard?')){
							url = url.replace('api/BIApi/GetDashboard?', `api/BIApi/GetDashboard?access_token=${CookieManager.GetAuthToken()}&`);
						}
						
						this._url(url);
					}
				});
			}

			if (this.Properties.Height) {
				_.each(this.Properties.Height.Properties, (property: any) => {
					if (!!property.HeightPX){
						this._heightPX(property.HeightPX);
					}
				});
			}
		}
	}
}